import { threeDStudioStore } from '../index'

/**
 * Stores the live viewer instance so the viewer sidebar (rendered outside
 * ViewerContext) can invoke imperative actions like setMeshVisibility,
 * removeMesh and setExplodedViewEnabled. Kept in the dedicated `staticViewer`
 * slice so per-model resets that rebuild the `viewer` slice never clobber it.
 * @param {object|null} instance - the cgt-viewer instance, or null when disposed
 */
export const setViewerInstance = (instance) => {
  threeDStudioStore.setState((state) => ({
    staticViewer: { ...state.staticViewer, instance },
  }))
}

/**
 * Marks the start of a model swap rendered behind a frozen frame. Lives in this
 * slice rather than `viewer` because `setOpenedModel` rebuilds `viewer` from its
 * defaults on every model switch - which is exactly when a swap begins, so the
 * flag would be wiped by the change that sets it.
 * @param {object|null} frozenStats - viewer.getStats() captured before the
 *   unload zeroes it, so the details card can hold the outgoing counts
 */
export const beginViewerSwap = (frozenStats) => {
  threeDStudioStore.setState((state) => ({
    staticViewer: { ...state.staticViewer, isSwapping: true, frozenStats },
  }))
}

export const endViewerSwap = () => {
  threeDStudioStore.setState((state) => ({
    staticViewer: { ...state.staticViewer, isSwapping: false, frozenStats: null },
  }))
}
